import {useMemo} from 'react';
import {QueryClient, useQuery} from '@tanstack/react-query';
import {getFiltersAPI, ParsedDataGFR} from '@services/new/common/getFilters';

// Generate a consistent query key
const getFiltersQueryKey = (payload: string) => ['filters', payload];

// Prefetch Filters
export const prefetchFilters = async (
  queryClient: QueryClient,
  payload: string
) => {
  const response = getFiltersAPI(payload).send();
  await queryClient.prefetchQuery({
    queryKey: getFiltersQueryKey(payload),
    queryFn: async () => response,
  });
  return response;
};

// Use Filters Hook
const useFilters = (payload: string) => {
  const queryFn = useMemo(() => {
    const apiService = getFiltersAPI(payload);
    return () => apiService.send();
  }, [payload]);

  return useQuery<ParsedDataGFR>({
    queryKey: getFiltersQueryKey(payload),
    queryFn,
    staleTime: Infinity, // Prevents unnecessary re-fetches
    placeholderData: (previousData) => previousData,
  });
};

export default useFilters;
